import WorkspacesIcon from "@mui/icons-material/Workspaces";
import { List, ListItemButton, Typography } from "@mui/material";
import { TWTooltip } from "apps/web/src/componentLibrary/TWTooltip/TWTooltip";
import { Link, useNavigate, useParams } from "react-router-dom-v5-compat";
import NotificationCountLabel from "../../components/Notification/CountLabel";
import { getNavOrgAthleteWithTeam, getNavOrgAthleteWithTeamFoodLogs } from "../../pages/Auth/Org/Athlete/AthletePaths";
import { TeamPageAthleteFragment } from "../../types";
interface TeamRosterListProps {
  athletes: readonly TeamPageAthleteFragment[];
}

export const TeamRosterList = ({ athletes }: TeamRosterListProps) => {
  const { teamId: maybeTeamId } = useParams();
  const navigate = useNavigate();

  return (
    <List sx={{ overflowY: "auto", flexGrow: 1, flexShrink: 1 }}>
      {athletes.map(athlete => {
        const to =
          athlete.timelineMealNotifications.length > 0
            ? getNavOrgAthleteWithTeamFoodLogs(athlete.id, maybeTeamId || "")
            : getNavOrgAthleteWithTeam(athlete.id, maybeTeamId || "");
        return (
          <li key={athlete.id}>
            <ListItemButton
              sx={{ display: "flex", alignItems: "center", pr: 2 }}
              component={Link}
              to={to}
              onKeyDown={event => {
                if (event.key === " " || event.key === "Spacebar") {
                  event.preventDefault();
                  navigate(to);
                }
              }}
            >
              <Typography>{athlete.lastName + ", " + athlete.firstName}</Typography>
              <NotificationCountLabel max={9} notifications={athlete.timelineMealNotifications} />
              {athlete.teams.length > 1 && (
                <TWTooltip title={athlete.lastName + ", " + athlete.firstName} subcopy="This athlete is on multiple teams" sx={{ ml: 1 }}>
                  <WorkspacesIcon />
                </TWTooltip>
              )}
            </ListItemButton>
          </li>
        );
      })}
    </List>
  );
};
